module.exports = __webpack_public_path__ + "img/kiseb-image2.d80e3219.png";